export enum ProductEnvironment {
	DEVELOPMENT = 'DEVELOPMENT',
	STAGING = 'STAGING',
	PRODUCTION = 'PRODUCTION',
}

export enum ForgeCDNEnvironment {
	DEVELOPMENT = 'dev',
	STAGING = 'stg',
	PRODUCTION = 'prod',
}
